import React from "react";

const CurrentUser = React.createContext();

export default CurrentUser;
